import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet';
import SignupForm from './utils/SignupForm';
import { Link } from 'react-router-dom';
import HealthSection from './utils/HealthSection';

const UnderstandingHeartRateZonesForOptimalTraining = () => {
    return (
        <div>
            <Helmet>
                <title>Understanding Heart Rate Zones for Optimal Training | Ramp Physio and Fitness</title>
                <meta name="description" content="Master your training intensity by understanding heart rate zones with Ramp Physio and Fitness. Optimize your workouts for better health and fitness results." />
            </Helmet>
            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Master Your Workout Intensity</h1>
                    <h2>Unlock the potential of heart rate zone training at Ramp Physio and Fitness to tailor your exercise routine for maximum efficiency and results.</h2>
                    <p>Heart rate zones are a critical element in structuring your workouts to match your fitness goals. Understanding these zones allows you to train more effectively, ensuring that every session at Ramp Physio and Fitness is optimized for your personal health and fitness objectives. Let's explore how heart rate zone training can revolutionize your exercise regimen.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Service Detail" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>The Five Heart Rate Zones</h1>
                        <p>There are five heart rate zones, each corresponding to a different level of training intensity. From Zone 1, the lowest intensity level ideal for recovery and endurance building, to Zone 5, which is reserved for short bursts of maximum effort, understanding these zones is crucial for tailoring your workout to your specific fitness goals.</p>
                        <ul>
                            <li>Zone 1: 50-60% of maximum heart rate – Light intensity</li>
                            <li>Zone 2: 60-70% of maximum heart rate – Moderate intensity</li>
                            <li>Zone 3: 70-80% of maximum heart rate – Aerobic training</li>
                            <li>Zone 4: 80-90% of maximum heart rate – Threshold training</li>
                            <li>Zone 5: 90-100% of maximum heart rate – Anaerobic training</li>
                        </ul>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/bike.webp" alt="Exercise" />
                    </div>
                </div>
            </SkewedContainer>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Calculating Your Heart Rate Zones</h1>
                    <p>Knowing how to calculate your heart rate zones is a fundamental step in applying them to your workouts. The most common method involves subtracting your age from 220 to estimate your maximum heart rate. You can then multiply this number by the percentages for each zone to find your target heart rate ranges.</p>
                </div>
            </div>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={ndisLogo} alt="NDIS Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>
            
            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Benefits of Heart Rate Zone Training</h1>
                    <p>Training within specific heart rate zones can bring a multitude of benefits, including improved cardiovascular fitness, better fat burning, enhanced endurance, and more effective recovery. By aligning your workout intensity with the right zone, you can achieve your fitness goals more efficiently.</p>
                </div>
                <div className="intro-image">
                    <img src="../assets/bike.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/Gymfloor1.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Integrating Zones into Your Routine</h1>
                    <p>Incorporating heart rate zone training into your fitness routine can be done in various ways. Whether it's through interval training, steady-state cardio, or even weightlifting sessions, understanding and utilizing these zones can help you train smarter and with greater precision.</p>
                </div>
            </div>
            </SkewedContainer>
            <div className="service-intro-container5">
                <div className="service-intro-content5">
                    <h1>Monitoring Your Heart Rate</h1>
                    <p>Monitoring your heart rate during workouts is essential for staying within your desired heart rate zones. Wearable technology like heart rate monitors or smartwatches can provide real-time feedback, allowing you to adjust your intensity on the fly for optimal training.</p>
                </div>
            </div>
            <div className="service-intro-container6">
                <div className="service-intro-content6">
                    <h1>Customized Training Plans</h1>
                    <p>At Ramp Physio and Fitness, we offer personalized training plans that incorporate heart rate zone training to suit your individual fitness levels and goals. Our experienced trainers can guide you in understanding and applying these concepts to your workouts.</p>
                </div>
            </div>
            
    <SubpagesLink />
    <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default UnderstandingHeartRateZonesForOptimalTraining;